import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { EMPTY, Subscription } from 'rxjs';
import { ContractCreationFileType } from './contract-creation-file.type';
import { FileTypeItem } from './file-type.item';
import { ToastrService } from 'ngx-toastr';
import { FileDownloadService } from '../../../services/file-download.service';

@Component({
    selector: 'app-contract-from-file',
    templateUrl: './contract-from-file.component.html',
    styleUrls: ['./contract-from-file.component.css']
})
export class ContractFromFileComponent implements OnInit, OnDestroy {
    readonly fileTypes: FileTypeItem[] = [
        new FileTypeItem(ContractCreationFileType.Csv1Ee, 'Ricontrattualizzazione - Csv energia'),
        new FileTypeItem(ContractCreationFileType.Csv1Gg, 'Ricontrattualizzazione - Csv gas'),
        new FileTypeItem(ContractCreationFileType.Csv2Ee, 'Generico - Csv energia'),
        new FileTypeItem(ContractCreationFileType.Csv2Gg, 'Generico - Csv gas')
    ];

    fileType: ContractCreationFileType;
    file: File;
    private subscription: Subscription;
    workInProgress = false;

    constructor(private dataService: DataService,
                private toastr: ToastrService,
                private downloadService: FileDownloadService) {
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        if (this.subscription != null) {
            this.subscription.unsubscribe();
        }
    }


    chooseFile(file: File) {
        this.file = file;
    }

    submit() {
        if (this.workInProgress === true) {
            return;
        }
        this.workInProgress = true;
        this.subscription = this.dataService.createContractsFromCsv(this.file, this.fileType)
            .pipe(
                tap(resp => {
                    if (resp.isSuccessful()) {
                        const message = `Contratti creati: ${resp.contractsIds.length}\nErrori: ${resp.errors.length}`;
                        const title = `File elaborato con successo.`;
                        this.toastr.success(message, title);
                        /* Potrebbe verificarsi il caso in cui lo stato è Failure(<==> nessun contratto creato)
                        e tutte le righe hanno un errore. Questo caso necessita la creazione del report */
                    } else if (resp.isFailure() && resp.errors.length === 1) {
                        const message = resp.errors[0].message;
                        const title = `Errore durante l'elaborazione del file.`;
                        this.toastr.warning(message, title);
                    } else {
                        const message = `Contratti creati: ${resp.contractsIds.length}\nErrori: ${resp.errors.length}`;
                        const title = `Errore durante l'elaborazione del file.`;
                        this.toastr.warning(message, title);
                        // download report
                        try {
                            const content = resp.errors.map(e => e.message).join('\n');
                            const fileName = `errori_contratti_batch_${new Date().toISOString()}.txt`;
                            this.downloadService.downloadTextPlain(content, fileName);
                        } catch (e) {
                            console.warn(`Exception downloading error report`, e);
                            this.toastr.error(`Errore nel tentativo di scaricare il report elaborazione`);
                        }
                    }
                }),
                catchError(err => {
                    console.error(err);
                    this.toastr.error(`Errore non gestito durante l'elaborazione del file.`, `Attenzione`);
                    return EMPTY;
                }),
                finalize(() => {
                    this.workInProgress = false;
                })
            ).subscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/common/contract-from-file/contract-from-file.component.ts